import React from 'react';
import PropTypes from 'prop-types';

import IntegrationMaterialsSync from '../IntegrationMaterialSync';

const autoImportContent = (
  <div style={{ width: 500 }}>
    Ontraccr can automatically import Items from Sage Intacct.
    <br />
    <br />
    1. Make sure the Items have a name and description set.
    <br />
    <br />
    2. Items with names that conflict with existing Ontraccr Materials will not be imported.
    <br />
    <br />
    If you would rather see exactly which data will be imported from Sage Intacct and fill in any
    missing fields, disable Auto Import to do this manually.
  </div>
);

const getImportHelpText = (t) => (
  <div style={{ width: 500 }}>
    Select from this dropdown to either
    {' '}
    <b>Import</b>
    {' '}
    new Items from Sage Intacct or
    {' '}
    <b>Link</b>
    {' '}
    Sage Intacct Items to existing Ontraccr Materials
    <br />
    <br />
    <b>Import:</b>
    {' '}
    Materials must have a name and description to be imported into Ontraccr.
    <br />
    <b>Link:</b>
    {' '}
    Select an existing Ontraccr Material to link with the Sage Intacct Item.
  </div>
);

export default function SageIntacctMaterialSync({
  sageIntacctMaterials,
  onMaterialsChanged,
  importMaterials,
  divisionFilter,
}) {
  return (
    <IntegrationMaterialsSync
      integrationMaterials={sageIntacctMaterials}
      title="Sage Intacct"
      integrationKey="sageId"
      onMaterialsChanged={onMaterialsChanged}
      autoImportContent={autoImportContent}
      importHelpText={getImportHelpText()}
      importMaterials={importMaterials}
      divisionFilter={divisionFilter}
    />
  );
}

SageIntacctMaterialSync.propTypes = {
  sageIntacctMaterials: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    sageId: PropTypes.string,
    partNumber: PropTypes.string,
    code: PropTypes.string,
  })),
  onMaterialsChanged: PropTypes.func.isRequired,
  importMaterials: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    sageId: PropTypes.string,
  })),
  divisionFilter: PropTypes.instanceOf(Set),
};

SageIntacctMaterialSync.defaultProps = {
  sageIntacctMaterials: [],
  importMaterials: [],
  divisionFilter: null,
};
